import React, { useMemo } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const DEFAULT_DATA = [
    { label: "APH", value: 5, color: "#5e72e4" },
    { label: "PPH", value: 17, color: "#11cdef" },
    { label: "Pregnancy-related infection & sepsis fever", value: 8, color: "#2dce89" },
    { label: "Abortive complication", value: 1, color: "#fb6340" },
    { label: "Obstructed / Prolonged labour", value: 0, color: "#f5365c" },
    { label: "Severe hypertension & fits in pregnancy", value: 17, color: "#8965e0" },
    { label: "Other unknown causes", value: 136, color: "#c4f2f0" },
];

export default function MaternalDeathsPieChart({ selectedDistrict = null }) {
    // Apply seed logic: 20% of default values for district view
    const data = useMemo(() => {
        if (!selectedDistrict) return DEFAULT_DATA;
        return DEFAULT_DATA.map(d => ({
            ...d,
            value: Math.round(d.value * 0.2)
        }));
    }, [selectedDistrict]);

    const chartData = {
        labels: data.map((d) => d.label),
        datasets: [
            {
                data: data.map((d) => d.value),
                backgroundColor: data.map((d) => d.color),
                borderColor: "#fff",
                borderWidth: 2,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            datalabels: { display: false },
            legend: {
                position: "right",
                labels: {
                    boxWidth: 20,
                    padding: 15,
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                        const value = context.raw;
                        const percentage = total ? ((value / total) * 100).toFixed(2) + "%" : "0%";
                        return `${context.label}: ${value} (${percentage})`;
                    },
                },
            },
        },
    };

    return (
        <div className="bg-white p-4 rounded-lg shadow-md w-full mx-auto">
            <h5 className="classHeading mb-4">Maternal Deaths Breakdown</h5>
            <div className="relative" style={{ height: 270, width: "100%" }}>
                <Pie
                    data={chartData}
                    options={{ ...options, maintainAspectRatio: false }}
                />
            </div>
        </div>
    );
}
